import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Table from '../Tables/Table';
import Pagination from '../Pagination/Pagination';

const limitTemplate = [
  {
    id: 0,
    count: 15,
  },
  {
    id: 1,
    count: 30,
  },
  {
    id: 2,
    count: 60,
  },
  {
    id: 3,
    count: 100,
  },
];

const TableAndPagination = ({
  onChange, totalPage = 1, page = 1, limit = 15, data, header, loading, className = '',
  onClick = () => {}, limitCounts = limitTemplate, hidePagination, sort, sortBy, onSortBy, notFoundText,
}) => {
  const [pageLoading, setPageLoading] = useState(false);

  const onChangeLoading = async (path, count) => {
    setPageLoading(true);
    await onChange(path, count);
    setPageLoading(false);
  };

  return (
    <>
      <div style={{
        position: 'relative', height: '100%', width: '100%',
      }}
      >
        <Table
          data={data}
          header={header}
          className={className}
          onClick={onClick}
          sort={sort}
          sortBy={sortBy}
          onSortBy={onSortBy}
          loading={pageLoading || loading}
          notFoundText={notFoundText}
        />
      </div>

      {!!data.length && !hidePagination && (
      <Pagination
        onChange={onChangeLoading}
        page={page}
        totalPage={totalPage}
        limit={limit}
        limitCounts={limitCounts}
      />
      )}
    </>
  );
};

TableAndPagination.propTypes = {
  onChange: PropTypes.func.isRequired,
  onClick: PropTypes.func,
  totalPage: PropTypes.number,
  page: PropTypes.number,
  limit: PropTypes.number,
  limitCounts: PropTypes.array,
  header: PropTypes.array.isRequired,
  data: PropTypes.array.isRequired,
  hidePagination: PropTypes.bool,
  sortBy: PropTypes.string,
  sort: PropTypes.oneOf(['asc', 'desc']),
  onSortBy: PropTypes.func,
  className: PropTypes.string,
  notFoundText: PropTypes.string,
};

export default TableAndPagination;
